export default __webpack_public_path__ + "static/media/menu_close.fec497be.svg";